import React, { HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './Loader.module.scss';

type Props = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  label?: string;
};

export const Loader = ({
  label = 'Loading',
  className,
  ...props
}: Props): JSX.Element => {
  return (
    <span
      role="status"
      aria-label={label}
      data-design-system-loader
      className={clsx(styles.loader, className)}
      {...props}
    >
      <span aria-hidden={true} data-design-system-loader-dot />
      <span aria-hidden={true} data-design-system-loader-dot />
      <span aria-hidden={true} data-design-system-loader-dot />
    </span>
  );
};

export type { Props as LoaderProps };
